//Libraries
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

import { ReactComponent as EfzBackground } from 'assets/@efz/backgrounds/login-background.svg';
import { ReactComponent as PlatformLogo } from 'assets/@efz/logos/logo-efz.svg';

//Components
import LoginForm from 'components/login/Form';
import IntlMessages from 'components/util/IntlMessages';

//Constants
import { BASENAME_URL_OPPORTUNITIES } from 'constants/settings';

//Pages
import Footer from 'pages/Restricted/shared/Footer';

//Services
import { isDefined, isFieldDefined } from 'services/util/auxiliaryUtils';

//Stores
import { useUserStore } from 'stores/user';

import { StyledLogin, StyledLoginContainer, StyledLoginContent, StyledLoginSVG } from './index.styled';

const Login = () => {
    const navigate = useNavigate();
    const {
        actions: { setIsUserAuthenticated },
        user,
    } = useUserStore();

    // componentWillUnmountWithUseEffect
    useEffect(() => {
        return () => {
            toast.dismiss(); // dismiss all notifications
        };
    }, []);

    // if user is authenticated, redirect
    useEffect(() => {
        const hasToken = isFieldDefined(localStorage?.getItem('userToken'));
        if (hasToken && user.auth.isUserAuthenticated && isDefined(user.user_type_id)) {
            navigate(BASENAME_URL_OPPORTUNITIES);
        }

        if (!hasToken && user.auth.isUserAuthenticated) setIsUserAuthenticated(false);
    }, [user.auth.isUserAuthenticated]); //eslint-disable-line

    return (
        <StyledLogin>
            <StyledLoginSVG>
                <div className="login-svg-ng">
                    <EfzBackground preserveAspectRatio="xMidYMid slice" />
                </div>
            </StyledLoginSVG>

            <StyledLoginContainer>
                <StyledLoginContent>
                    {/* Header */}
                    <div className="login-card-header">
                        <PlatformLogo />
                    </div>
                    {/* Body */}
                    <div className="login-card-body">
                        <h1>
                            <IntlMessages id={'page.login.title'} />
                        </h1>

                        <LoginForm />
                    </div>
                </StyledLoginContent>
            </StyledLoginContainer>

            <Footer isUserAuthenticated={user.auth.isUserAuthenticated} />
        </StyledLogin>
    );
};

export default Login;
